/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import { animationStyles as a } from "@progress/kendo-react-common";
const e = (t) => {
  if (!t || !t.ownerDocument.defaultView)
    return 0;
  const o = t.ownerDocument.defaultView.getComputedStyle(t), n = parseFloat(o.marginTop), r = parseFloat(o.marginBottom);
  return t.offsetHeight + n + r;
}, i = (t) => {
  if (!t || !t.ownerDocument.defaultView)
    return 0;
  const o = t.ownerDocument.defaultView.getComputedStyle(t), n = parseFloat(o.marginLeft), r = parseFloat(o.marginRight);
  return t.offsetWidth + n + r;
}, c = {
  outerHeight: e,
  outerWidth: i,
  styles: a
};
export {
  c as default
};
